import axiosInstance from '@/utils/api.js'

var state = {
  switchTypes: []
}

var getters = {
  SWITCH_TYPES: (state) => {
    return state.switchTypes
  }
}

var mutations = {
  SET_SWITCH_TYPES: (state, payload) => {
    state.switchTypes = payload
  }
}

var actions = {
  GET_SWITCH_TYPES: async (context, payload) => {
    let result = await axiosInstance.get('/inventory/switch_types')
    if (result.status === 200) {
      context.commit('SET_SWITCH_TYPES', result.data)
    }
  },
  CREATE_SWITCH_TYPES: (context, payload) => {
    return axiosInstance.post('/inventory/switch_types', payload)
  },
  UPDATE_SWITCH_TYPES: (context, payload) => {
    return axiosInstance.put('/inventory/switch_types', payload)
  },
  DELETE_SWITCH_TYPES: (context, payload) => {
    return axiosInstance.delete('/inventory/switch_types?profile_id=' + payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/inventory/switchTypes.js